import { useEffect, useState } from "react";
import { config } from "./config";
import { Navigate, useSearchParams } from "react-router-dom";
import axios from "axios";
import { App } from "./App";
import { Reports43101App } from "./Reports43101App";
import { ReportDetailApp } from "./ReportDetailApp";
import { ChatApp } from "./ChatApp";
import Cookies from "js-cookie";

const LoginWindow = () => {
  useEffect(() => {
    window.location.href = `${config.COGNITO_AUTH_BASE_URL}/${config.COGNITO_AUTH_LOGIN_ENDPOINT}?client_id=${config.COGNITO_CLIENT_ID}&response_type=${config.COGNITO_RESPONSE_TYPE}&redirect_uri=${config.COGNITO_REDIRECT_URL}`;
  }, []);
  return "Redirecting to Login UI";
};

const useAuthVerification = () => {
  const [hasCorrectCredentials, setHasCorrectCredentials] = useState(false);
  const [credentialsVerificationComplete, setCredentialsVerificationComplete] =
    useState(false);

  useEffect(() => {
    const verifyCredentials = async () => {
      return await axios({
        method: "GET",
        url: config.AUTH_VERIFICATION_URL,
        withCredentials: true,
      });
    };
    verifyCredentials()
      .then((resp) => {
        setHasCorrectCredentials(true);
        Cookies.set("__needle-id-token", resp.data["idToken"]);
      })
      .catch((e) => console.log(e))
      .finally(() => setCredentialsVerificationComplete(true));
  }, []);

  return { hasCorrectCredentials, credentialsVerificationComplete };
};

export const AppAuthWrapper = () => {
  const { hasCorrectCredentials, credentialsVerificationComplete } =
    useAuthVerification();

  return (
    <>
      {credentialsVerificationComplete ? (
        hasCorrectCredentials ? (
          <App></App>
        ) : (
          <LoginWindow />
        )
      ) : (
        "Verifying Credentials"
      )}
    </>
  );
};

export const Reports43101AuthWrapper = () => {
  const { hasCorrectCredentials, credentialsVerificationComplete } =
    useAuthVerification();

  return (
    <>
      {credentialsVerificationComplete ? (
        hasCorrectCredentials ? (
          <Reports43101App />
        ) : (
          <LoginWindow />
        )
      ) : (
        "Verifying Credentials"
      )}
    </>
  );
};

export const ReportDetailAuthWrapper = () => {
  const { hasCorrectCredentials, credentialsVerificationComplete } =
    useAuthVerification();

  return (
    <>
      {credentialsVerificationComplete ? (
        hasCorrectCredentials ? (
          <ReportDetailApp />
        ) : (
          <LoginWindow />
        )
      ) : (
        "Verifying Credentials"
      )}
    </>
  );
};

export const ChatAuthWrapper = () => {
  const { hasCorrectCredentials, credentialsVerificationComplete } =
    useAuthVerification();

  return (
    <>
      {credentialsVerificationComplete ? (
        hasCorrectCredentials ? (
          <ChatApp />
        ) : (
          <LoginWindow />
        )
      ) : (
        "Verifying Credentials"
      )}
    </>
  );
};

export const LoginHandler = () => {
  const [searchParams] = useSearchParams();
  const [authComplete, setAuthComplete] = useState(false);

  useEffect(() => {
    const code = searchParams.get("code");
    const fetchTokens = async () => {
      const resp = await axios({
        method: "GET",
        url: config.FETCH_TOKEN_URL,
        withCredentials: true,
        params: {
          code,
        },
      });
      Cookies.set("__needle-id-token", resp.data["idToken"]);
    };
    fetchTokens()
      .catch((e) => console.log(e))
      .finally(() => setAuthComplete(true));
  }, [searchParams]);
  return <>{authComplete ? <Navigate to="/" /> : "Authenticating"}</>;
};
